module.exports = __webpack_public_path__ + "img/7754b88.png";